/**
 * 先頭スラッシュ正規化ヘルパ（相対URL化共通処理）
 * - http(s):// は素通し
 * - それ以外は先頭スラッシュを1つに正規化して返す（// や スキーム無し相対の事故防止）
 */
export const toRelativePath = (s: string): string => {
  if (s.startsWith('http://') || s.startsWith('https://')) {
    return s;
  }
  return '/' + s.replace(/^\/+/, '');
};

export const normalizeVideoImagePath = (imagePath?: string | null): string => {
  if (!imagePath) {
    return '';
  }

  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  if (imagePath.startsWith('uploads/')) {
    return `/${imagePath}`;
  }

  if (imagePath.startsWith('/uploads/')) {
    return imagePath;
  }

  return imagePath;
};
